import axios from "axios";

// CRA solo expone variables con prefijo REACT_APP_ (ver .env).
const baseURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

// Llave del demo. El backend la exige en enrolar/analizar/galería porque corre
// en una máquina personal expuesta a internet por el túnel de Cloudflare.
// Ojo: al compilar queda dentro del bundle público, así que NO es un secreto —
// solo frena el abuso casual de escaneos automatizados.
const demoKey = process.env.REACT_APP_DEMO_KEY || "";

export const api = axios.create({
  baseURL,
  headers: demoKey ? { "X-Demo-Key": demoKey } : {},
});

// Sonda de vida del backend. Es el unico endpoint sin llave, a proposito:
// sirve para saber si el tunel y el motor estan arriba ANTES de que el usuario
// intente subir un video. Devuelve { status, runner, threshold }.
export async function getHealth() {
  const { data } = await api.get("/api/health", { timeout: 8000 });
  return data;
}

// Enrola un sujeto de referencia (nombre + video). Devuelve { job_id }.
export async function enrollSubject(name, file) {
  const fd = new FormData();
  fd.append("name", name);
  fd.append("file", file);
  const { data } = await api.post("/api/gallery", fd);
  return data;
}

// Lista los sujetos enrolados. Devuelve [{ id, name, created_at, frames }].
export async function listGallery() {
  const { data } = await api.get("/api/gallery");
  return data.subjects || [];
}

// Sube un video probe para identificar contra la galería. Devuelve { job_id }.
export async function analyzeVideo(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/api/analyze", fd);
  return data;
}

// Estado/resultado de un job (progreso, matches, eventos).
export async function getJob(id) {
  const { data } = await api.get(`/api/jobs/${id}`);
  return data;
}

// URL del video anotado de un job de análisis.
export function jobVideoUrl(id) {
  return `${baseURL}/api/jobs/${id}/video`;
}
